// @flow
//Core
import React, { useState, useEffect } from 'react';
import { Grid, Box, Typography, Button, Chip } from '@material-ui/core';
import classNames from 'classnames';
import get from 'lodash.get';
import formatDate from 'date-format';
//Local
import { Card } from '../..';
import { itemsStyles } from '../styles';
import JobPreviewImg from '../../../images/jobPreview.jpg';

const JobsSec = ({
  title,
  tags,
  items: initialItems,
  loadBy,
  handleCustomLoadMore,
  isLoaded: customIsLoaded,
  selectedTag,
  seeMoreText = 'もっと詳しく',
  isMobile,
}) => {
  const styles = itemsStyles();

  const [items, setItems] = useState(initialItems);
  const [filterBy, setFilterBy] = useState(null);
  const [loadedCount, setLoadedCount] = useState(loadBy);
  const [totalFilteredItemsCount, setTotalFilteredItemsCount] = useState(
    initialItems.length
  );

  const isLoaded =
    typeof customIsLoaded === 'boolean'
      ? customIsLoaded
      : loadedCount >= initialItems.length;

  const filterItemsByTag = (data, inputFilterBy = filterBy) =>
    data.filter((item) =>
      inputFilterBy
        ? get(item, 'parent.id', []) === inputFilterBy
        : initialItems
    );

  const handleTagClick = (id) => {
    setLoadedCount(loadBy);
    setTotalFilteredItemsCount(filterItemsByTag(initialItems, id).length);
    setFilterBy(id);
  };

  const handleLoadMoreClick = () => {
    setLoadedCount(
      loadedCount + loadBy <= initialItems.length
        ? loadedCount + loadBy
        : initialItems.length
    );
  };

  const filterLoadedItems = (data) => data.slice(0, loadedCount);

  useEffect(() => {
    setItems(
      handleCustomLoadMore
        ? filterItemsByTag(initialItems)
        : filterLoadedItems(filterItemsByTag(initialItems))
    );
  }, [initialItems, filterBy, loadedCount]);

  useEffect(() => {
    const tag = tags.find((t) => t.name === selectedTag);

    if (!tag) {
      setFilterBy(null);
    } else if (tag.id !== filterBy) {
      setFilterBy(tag.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTag, tags]);

  const tagsJSX = [
    {
      name: 'すべての記事',
      id: null,
    },
    ...tags,
  ].map((item, index) => (
    <Chip
      label={item.name}
      onClick={() => handleTagClick(item.id)}
      key={index}
      clickable
      color="secondary"
      className={classNames(styles.tag, {
        [styles.activeTag]: item.id === filterBy,
      })}
    />
  ));

  const itemsJSX = items.map((item, index) => {
    const date = new Date(
      item.jobObj.openings && item.jobObj.openings.length > 0
        ? item.jobObj.openings[item.jobObj.openings.length - 1].opened_at
        : get(item, 'created_at')
    );

    return (
      <Grid xs={12} md={4} key={index} item>
        <Card
          img={JobPreviewImg}
          title={get(item, 'title')}
          tags={[item.parent.name]}
          link={`/media_center/work_life/recruitment/job/${get(
            item,
            'greenhouseId'
          )}`}
          variant="primary"
          theme="light"
          size="md"
          className={styles.card}
          date={formatDate('yyyy/MM/dd', date)}
        />
      </Grid>
    );
  });

  return (
    <section className={styles.section} id="fourthSec">
      <Typography className={styles.title} variant="h2" id="openings">
        {title}
      </Typography>
      {/* <Typography
        className={classNames(
          styles.subtitle,
          typography.withDividerLeftPurple
        )}
        variant="body1"
      >
        {subtitle}
      </Typography> */}
      <Box className={styles.tags}>{tagsJSX}</Box>
      <Grid container spacing={isMobile ? 0 : 6}>
        {itemsJSX}
      </Grid>
      {!isLoaded && items.length < totalFilteredItemsCount && (
        <Box textAlign="center">
          <Button
            className={styles.loadMoreBtn}
            variant="outlined"
            color="primary"
            onClick={handleCustomLoadMore || handleLoadMoreClick}
          >
            {seeMoreText}
          </Button>
        </Box>
      )}
    </section>
  );
};

JobsSec.defaultProps = {
  items: [],
  handleCustomLoadMore: undefined,
  isLoaded: undefined,
  loadBy: 9,
  selectedTag: '',
};

export default JobsSec;
